import React from 'react';
import { AreaField, Button, Grid, UserIconStyled } from 'ui-toolkit';
import { Form, Formik } from 'formik';
import { UUID } from '../../../types/shared/UUID';
import { eAuthorType } from '../../../types/order/comment/eAuthorTypes';
import { clientCommentFormValidation } from '../../../validation/clientPortal/clientCommentFormValidation';
import { ICommentCreateRequest } from '../../../API/order/comments/Comments';
import { eCommentScope } from '../../../types/order/comment/eCommentScope';
import { eCommentType } from '../../../types/order/comment/eCommentType';

export const AddNewCommentForm: React.FC<{
  lenderInitials: string;
  onSubmit: (request: ICommentCreateRequest) => void;
  onCancel: () => void;
  orderId: UUID;
}> = ({ lenderInitials, orderId, onSubmit, onCancel }) => {
  const initialValues: ICommentCreateRequest = {
    orderId: orderId,
    scope: eCommentScope.external,
    type: eCommentType.general,
    relevantParty: eAuthorType.ClientUser,
    content: '',
  };

  return (
    <Grid templateColumns={'min-content 1fr'} alignItems={'center'}>
      {lenderInitials ? <UserIconStyled>{lenderInitials}</UserIconStyled> : <div />}
      <Grid>
        <Formik
          initialValues={initialValues}
          onReset={onCancel}
          onSubmit={(values, { resetForm }) => {
            onSubmit(values);
            resetForm();
          }}
          validationSchema={clientCommentFormValidation}
        >
          {({ isValid, dirty, isSubmitting }) => (
            <Form>
              <Grid>
                <AreaField name={'content'} placeholder={'Leave a comment'} rows={1} />
                {dirty && (
                  <Grid columnCount={2}>
                    <Button intent={'primary'} type={'submit'} disabled={isSubmitting || !isValid}>
                      Add comment
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};
